import { BeWizrModel } from './BeWizrModel'

export class BeWizrProfile extends BeWizrModel {

  hasDashboardAccess: boolean = false

}